import { WebshopCheckoutEndpoint as WebshopCheckoutEndpointInterface } from '@apiClient/interfaces/endpoints/WebshopCheckout.endpoint';
import ApiResponseDto from '@apiClient/interfaces/response/ApiResponse.dto';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import CheckoutInitRequestDto from '@/projectRoot/api-client/interfaces/request/webshop/CheckoutInitRequest.dto';
import CheckoutDto from '@/projectRoot/api-client/interfaces/models/webshop/checkout/Checkout.dto';
import CheckoutInsertStepRequestDto from '@/projectRoot/api-client/interfaces/request/webshop/CheckoutInsertStepRequest.dto';
import CheckoutCustomerRequestDto from '@/projectRoot/api-client/interfaces/request/webshop/CheckoutCustomerRequest.dto';
import CheckoutBillingRequestDto from '@/projectRoot/api-client/interfaces/request/webshop/CheckoutBillingRequest.dto';
import CheckoutConfirmRequestDto from '@/projectRoot/api-client/interfaces/request/webshop/CheckoutConfirmRequest.dto';

export class WebshopCheckoutEndpoint implements WebshopCheckoutEndpointInterface {

    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = "force-cache") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
    * /api/webshop/checkout/init
    */
    async init(state: CheckoutInitRequestDto): Promise<ApiResponseDto<CheckoutDto, undefined>> {
        return this._httpClient
            .post(`webshop/checkout/init`, { json: state, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<CheckoutDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/webshop/checkout/{id}
     */
    async single(id: string): Promise<ApiResponseDto<CheckoutDto, undefined>> {
        return this._httpClient
            .get(`webshop/checkout/${id}`, { cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<CheckoutDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/webshop/checkout/{id}/insert-step
     */
    async insertStep(state: CheckoutInsertStepRequestDto): Promise<ApiResponseDto<CheckoutDto, undefined>> {
        return this._httpClient
            .post(`webshop/checkout/${state.checkout_id}/insert-step`, { json: state, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<CheckoutDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/webshop/checkout/{id}/customer
     */
    async customer(state: CheckoutCustomerRequestDto): Promise<ApiResponseDto<CheckoutDto, undefined>> {
        // let withoutId = {...state};
        // delete(withoutId.checkout_id);
        return this._httpClient
            .post(`webshop/checkout/${state.checkout_id}/customer`, { json: state, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                // console.log('kyResponse: ', kyResponse);
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<CheckoutDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/webshop/checkout/{id}/billing
     */
    async billing(state: CheckoutBillingRequestDto): Promise<ApiResponseDto<CheckoutDto, undefined>> {
        // let withoutId = {...state};
        // delete(withoutId.checkout_id);
        return this._httpClient
            .post(`webshop/checkout/${state.checkout_id}/billing`, { json: state, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                // console.log('kyResponse: ', kyResponse);
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<CheckoutDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/webshop/checkout/{id}/delivery
     */
    async delivery(state: CheckoutBillingRequestDto): Promise<ApiResponseDto<CheckoutDto, undefined>> {
        // let withoutId = {...state};
        // delete(withoutId.checkout_id);
        return this._httpClient
            .post(`webshop/checkout/${state.checkout_id}/delivery`, { json: state, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                // console.log('kyResponse: ', kyResponse);
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<CheckoutDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/webshop/checkout/{id}/confirm
     */
    async confirm(state: CheckoutConfirmRequestDto): Promise<ApiResponseDto<CheckoutDto, undefined>> {
        // let withoutId = {...state};
        // delete(withoutId.checkout_id);
        return this._httpClient
            .post(`webshop/checkout/${state.checkout_id}/confirm`, { json: state, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                // console.log('kyResponse: ', kyResponse);
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<CheckoutDto, undefined> = await kyResponse.json();
                return response;
            });
    }

}

export default WebshopCheckoutEndpoint;